import { $http } from '../stores/http';

export async function fetchHardwareOutputs() {
  const payload = await $http('GET', '/ventuz/hardware/outputs');
  return JSON.parse(payload);
}

export async function saveHardwareOutputs(outputs) {
  const payload = await $http(
    'PUT',
    '/ventuz/hardware/outputs',
    JSON.stringify({ outputs })
  );
  return JSON.parse(payload);
}

export async function fetchHardwareCapabilities() {
  const payload = await $http('GET', '/ventuz/hardware/capabilities');
  return JSON.parse(payload);
}
